/* global SWDLocalise */
import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import history from 'instantsearch.js/es/lib/routers/history';
import {
    configure,
    pagination,
    searchBox,
    stats,
} from 'instantsearch.js/es/widgets';
import { connectMenu } from 'instantsearch.js/es/connectors';
import customHits from './widgets/hits-post';
import customMenuSelectCategory from './widgets/menu-select-category';

const searchForm = document.querySelector('.js-post-search-form');
const searchResults = document.querySelector('.js-post-search-results');

const setup = () => {
    const algoliaClient = algoliasearch(
        SWDLocalise.algoliaAppID,
        SWDLocalise.algoliaAPIKey,
    );

    const searchClient = {
        ...algoliaClient,
    };

    const indexName = `${SWDLocalise.algoliaIndex}post`;

    const search = instantsearch({
        searchClient,
        indexName,
        routing: {
            router: history({
                createURL({ qsModule, routeState, location }) {
                    const queryParameters = {};

                    // query
                    if (routeState.query) {
                        queryParameters.query = encodeURIComponent(routeState.query);
                    }

                    // page
                    if (routeState.postspage !== 1) {
                        queryParameters.postspage = routeState.postspage;
                    }

                    // category
                    if (routeState.category) {
                        queryParameters.category = routeState.category;
                    }

                    const queryString = qsModule.stringify(queryParameters, {
                        addQueryPrefix: true,
                        arrayFormat: 'repeat',
                    });

                    // handle single URL
                    return `${location.origin + location.pathname + queryString}`;
                },

                parseURL({ qsModule, location }) {
                    const {
                        query = '',
                        postspage,
                        category = '',
                    } = qsModule.parse(
                        location.search.slice(1),
                    );

                    return {
                        query: decodeURIComponent(query),
                        postspage,
                        category,
                    };
                },
            }),

            stateMapping: {
                stateToRoute(uiState) {
                    const indexUiState = uiState.wp_post || {};

                    return {
                        query: indexUiState.query,
                        postspage: indexUiState.page,
                        category: indexUiState.menu && indexUiState.menu['taxonomies.category'],
                    };
                },

                routeToState(routeState) {
                    return {
                        wp_post: {
                            query: routeState.query,
                            page: routeState.postspage,
                            menu: {
                                'taxonomies.category': routeState.category,
                            },
                        },
                    };
                },
            },
        },
        searchFunction(helper) {
            if (searchResults.dataset.tag !== undefined) {
                helper
                    .clearRefinements('taxonomies.tag')
                    .addFacetRefinement('taxonomies.tag', searchResults.dataset.tag);
            }

            helper.search();
        },
        future: {
            preserveSharedStateOnUnmount: true,
        },
    });

    const virtualMenu = connectMenu(() => null);

    search.addWidgets([
        configure({
            distinct: false,
            facets: ['taxonomies.tag'],
        }),

        virtualMenu({
            attribute: 'taxonomies.tag',
        }),

        customMenuSelectCategory({
            container: document.querySelector('.js-post-search-cats'),
            attribute: 'taxonomies.category',
            sortBy: ['name:asc'],
            allLabel: 'All Articles',
        }),

        searchBox({
            container: searchForm,
            placeholder: 'Search',
        }),

        stats({
            container: document.querySelector('.js-post-search-stats'),
            templates: {
                text(data, { html }) {
                    let count = '';

                    if (data.hasManyResults) {
                        count += `${data.nbHits} Articles`;
                    } else if (data.hasOneResult) {
                        count += '1 Article';
                    } else {
                        count += 'No Articles';
                    }

                    return html`${count}`;
                },
            },
        }),

        customHits({
            container: document.querySelector('.js-post-search-results'),
        }),

        pagination({
            container: document.querySelector('.js-post-search-pagination'),
        }),
    ]);

    search.start();
};

const init = () => {
    if (!searchForm) return;
    setup();
};

export default init;
